module.exports = __webpack_public_path__ + "img/1.523fe714.png";